import { render, staticRenderFns } from "./coupon-add.vue?vue&type=template&id=1e74c827&scoped=true&"
import script from "./coupon-add.vue?vue&type=script&lang=js&"
export * from "./coupon-add.vue?vue&type=script&lang=js&"
import style0 from "./coupon-add.vue?vue&type=style&index=0&id=1e74c827&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74c827",
  null
  
)

export default component.exports